export default "__VITE_ASSET__$FJcyF9w__"